import MedicalRequest from "@/views/medical_requests/medical_request.vue";
import MedicalRequests from "@/views/medical_requests/index.vue";

export default [
  {
    path: "solicitacao-exames",
    name: "Solicitação de exame",
    component: MedicalRequests,
  },
  // {
  //   path: "solicitacao-exames/:medicalRequestId",
  //   name: "Editar solicitação de exame",
  //   props: true,
  //   component: MedicalRequest,
  // },
  {
    path: "solicitacao-exames/nova",
    name: "Nova solicitação de exame",
    component: MedicalRequest,
  },
];
